import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SkeletonContainer from '../Layout/SkeletonContainer';

export default class Reports extends Component {
    render(){
        return (
            <SkeletonContainer title="REPORTS">
                <div><Link to="/reports/1">Report 1 - Jobs by resource</Link></div><br/>
                <div><Link to="/reports/2">Report 2 - Jobs by type</Link></div><br/>
                <div><Link to="/reports/3">Report 3 - Jobs by location</Link></div><br/>
                <div><Link to="/reports/4">Report 4 - Jobs by requester</Link></div><br/>
                <div><Link to="/reports/5">Report 5 - Open jobs ageing by type</Link></div><br/>
                <div><Link to="/reports/6">Report 6 - Open jobs ageing by resource</Link></div><br/>
                <div><Link to="/reports/7">Report 7 - Open jobs ageing by meta location</Link></div><br/>
                <div><Link to="/reports/8">Report 8 - Handyman</Link></div><br/>
                <div><Link to="/reports/9">Report 9 - Export</Link></div><br/>
                <div><Link to="/reports/10">Report 10 - Jobs by sub location</Link></div><br/>
            </SkeletonContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/App/Reports/index.js